import { ArrowDownToLine, CheckCircle2, Info, Music, Share, Smartphone } from 'lucide-react'
import { useState } from 'react'

import { Button, toast } from '@/components/ui'
import { ReleaseNotesDialog } from '@/features/releases/ReleaseNotesDialog'
import { APP_RELEASE } from '@/features/releases/releaseState'

import { Callout } from './Callout'
import { SettingsSection } from './SettingsSection'
import { useInstallPrompt } from './useInstallPrompt'

function InstallBlock() {
  const { state, promptInstall } = useInstallPrompt()
  const [prompting, setPrompting] = useState(false)

  async function handleInstall() {
    setPrompting(true)
    try {
      const outcome = await promptInstall()
      if (outcome === 'accepted') {
        toast.success('Installing Tunes', 'Look for it alongside your other apps.')
      }
    } finally {
      setPrompting(false)
    }
  }

  if (state === 'installed') {
    return (
      <Callout tone="success" icon={CheckCircle2} title="Installed">
        Tunes is installed on this device.
      </Callout>
    )
  }

  if (state === 'promptable') {
    return (
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-medium text-text">Install Tunes</p>
          <p className="mt-0.5 text-sm text-text-muted">
            Adds it to your home screen or app list, without the browser chrome.
          </p>
        </div>
        <Button loading={prompting} onClick={() => void handleInstall()}>
          <ArrowDownToLine className="h-4 w-4" aria-hidden="true" />
          Install app
        </Button>
      </div>
    )
  }

  if (state === 'ios-manual') {
    return (
      <Callout tone="info" icon={Share} title="Add Tunes to your Home Screen">
        In Safari, tap Share → Add to Home Screen.
      </Callout>
    )
  }

  return (
    <Callout tone="info" icon={Smartphone} title="Install Tunes">
      Look for Install or Add to Home Screen in your browser’s menu.
    </Callout>
  )
}

export function AboutSection() {
  const [notesOpen, setNotesOpen] = useState(false)
  return (
    <SettingsSection icon={Info} title="About">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span
            aria-hidden="true"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent"
          >
            <Music className="h-5 w-5 text-on-accent" />
          </span>
          <div className="min-w-0">
            <p className="text-base font-semibold text-text">Tunes <span className="ml-1 text-sm font-normal text-text-muted">v{APP_RELEASE.version}</span></p>
            <p className="text-sm text-text-muted">
              Your music, on your server.
            </p>
          </div>
        </div>

        <div>
          <Button variant="secondary" onClick={() => setNotesOpen(true)}>Release notes</Button>
        </div>
        <InstallBlock />
        <ReleaseNotesDialog open={notesOpen} onOpenChange={setNotesOpen} />
      </div>
    </SettingsSection>
  )
}
